import React, { useState } from "react";
import styles from "./Query.module.css";
import { Box, VStack, Text, Button, Input, HStack, Avatar, IconButton } from "@chakra-ui/react";
import { connect } from "react-redux";
import { TbMessageCircle, TbArrowRight, TbX } from "react-icons/tb";

const CommentCard = ({ data, onReply, onMoveTo }) => {
  const [isReplying, setIsReplying] = useState(false);
  const [replyText, setReplyText] = useState("");

  const handleSend = () => {
    if (replyText.trim()) {
      onReply(data, replyText);
      setReplyText("");
      setIsReplying(false);
    }
  };

  return (
    <Box
      w="100%"
      bg="#2d2d2d"
      borderRadius="md"
      mb={3}
      p={3}
      boxShadow="md"
      border="1px solid #3e3e42"
    >
      {/* Header / Question */}
      <HStack align="start" spacing={3} mb={2} onClick={() => onMoveTo(data)} cursor="pointer">
        <Avatar size="xs" name="Query" bg="blue.500" icon={<TbMessageCircle size="1rem" />} />
        <VStack align="start" spacing={0} w="full">
          <Text fontSize="xs" fontWeight="bold" color="blue.200">
            Comment
          </Text>
          <Text fontSize="sm" color="gray.200" lineHeight="short">
            {data.qns}
          </Text>
        </VStack>
      </HStack>

      {/* Answer / Existing Reply */}
      {data.ans && (
        <Box
          ml={8}
          mt={2}
          p={2}
          bg="rgba(255, 255, 255, 0.05)"
          borderRadius="md"
          borderLeft="2px solid"
          borderColor="green.400"
        >
          <Text fontSize="xs" fontWeight="bold" color="green.300" mb={1}>
            Reply
          </Text>
          <Text fontSize="sm" color="gray.300">
            {data.ans}
          </Text>
        </Box>
      )}

      {/* Reply Action */}
      {!data.ans && (
        <Box mt={3} ml={8}>
          {!isReplying ? (
            <Button
              size="xs"
              variant="ghost"
              color="#cccccc"
              _hover={{ bg: "rgba(255,255,255,0.1)", color: "#fff" }}
              leftIcon={<TbArrowRight />}
              onClick={() => setIsReplying(true)}
            >
              Reply
            </Button>
          ) : (
            <VStack align="stretch" spacing={2}>
              <Input
                size="sm"
                placeholder="Type your reply..."
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                bg="#1e1e1e"
                border="1px solid #3e3e42"
                color="white"
                _focus={{ borderColor: "blue.500" }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') handleSend();
                }}
              />
              <HStack justify="flex-end">
                <IconButton
                  icon={<TbX />}
                  size="xs"
                  aria-label="Cancel"
                  variant="ghost"
                  color="gray.400"
                  onClick={() => setIsReplying(false)}
                />
                <Button
                  size="xs"
                  colorScheme="blue"
                  onClick={handleSend}
                >
                  Send
                </Button>
              </HStack>
            </VStack>
          )}
        </Box>
      )}
    </Box>
  );
};


const Query = (props) => {

  const enterAnswer = (a, answer) => {
    if (!props.ace.current || !props.ace.current.editor) return;

    let lasttext = props.ace.current.editor.session.getLine(a.startrow);

    // Simple check similar to original logic
    if (a.ans === undefined) { // logic simplified for cleanliness, original was checking textatpos
      if (!a.endcol) {
        // Ensure proper insertion similar to original
        props.ace.current.editor.session.insert(
          { row: a.endrow, column: a.endCol },
          "{"
        );
        props.ace.current.editor.session.insert(
          { row: a.endrow, column: a.endCol + 1 }, answer
        )
        props.ace.current.editor.session.insert(
          { row: a.endrow, column: a.endCol + answer.length + 1 },
          "}"
        );
      }
    }
    // Force refresh or let the editor/parser pick up changes
    // Usually triggering a re-parse or rely on ace `onChange` if fully reactive
  };

  const movetothatline = (a) => {
    if (props.ace.current && props.ace.current.editor) {
      props.ace.current.editor.gotoLine(a.startrow + 1, 0, true);
      props.ace.current.editor.scrollToLine(a.startrow, true);
    }
  };

  return (
    <VStack
      overflowY="auto"
      overflowX="hidden"
      height="100%"
      p={2}
      spacing={0}
      align="stretch"
      css={{
        "&::-webkit-scrollbar": { width: "8px" },
        "&::-webkit-scrollbar-track": { background: "transparent" },
        "&::-webkit-scrollbar-thumb": { background: "#555", borderRadius: "4px" },
        "&::-webkit-scrollbar-thumb:hover": { background: "#777" },
      }}
    >
      {props.query && props.query.length > 0 ? (
        props.query.map((q, i) => (
          <CommentCard
            key={i}
            data={q}
            onReply={enterAnswer}
            onMoveTo={movetothatline}
          />
        ))
      ) : (
        <Box textAlign="center" py={10} px={6}>
          <Text color="gray.500" fontSize="sm">
            No comments found.
          </Text>
        </Box>
      )}
    </VStack>
  );
};

const mapStateToProps = (state, ownProps) => ({
  query: state.queries.queries,
  ace: ownProps.ace,
});

export default connect(mapStateToProps, null)(Query);
